const Hooks = {
    runScript(script, data) {






        // Create a deep copy of data to prevent direct modification of the original
        //const dataCopy = JSON.parse(JSON.stringify(data || {}));




        // Define utility functions matching the Go implementation
        const roundToTwoDecimal = (value) => {
            if (!value) return '';

            // Replace comma with period and convert to float
            let strValue = String(value).replace(',', '.');
            let floatValue = parseFloat(strValue);

            if (isNaN(floatValue)) return '';

            // Round to two decimal places
            let rounded = Math.round(floatValue * 100) / 100;

            // Format result to 2 decimal places
            return rounded.toFixed(2);
        };

        const roundToThreeDecimal = (value) => {
            if (!value) return '';

            // Replace comma with period and convert to float
            let strValue = String(value).replace(',', '.');
            let floatValue = parseFloat(strValue);

            if (isNaN(floatValue)) return '';

            // Round to three decimal places
            let rounded = Math.round(floatValue * 1000) / 1000;

            // Format result to 3 decimal places
            let resultStr = rounded.toFixed(3);

            // If the third decimal is 0, remove it
            let parts = resultStr.split('.');
            if (parts.length === 2 && parts[1].length === 3 && parts[1].charAt(2) === '0') {
                return parts[0] + '.' + parts[1].substring(0, 2);
            }

            return resultStr;
        };

        const calcPriceWithVat = (nettoString, vatString) => {

            try {
                const netto = parseFloat(nettoString.replace(',', '.') * 1000);
                const vat = parseFloat(vatString);
                const brutto = Math.round((netto * (100 + vat)) / 1000);
                const result = (brutto / 100).toFixed(2);
                if (result <= 0.0 || isNaN(result)) {
                    return "";
                }
                return result;
            } catch (error) {
                return "";
            }
        };

        const calcPricePerUnit = (nettoPrice, units) => {
            try {
                const netto = parseFloat(nettoPrice.replace(',', '.') * 10000);
                const unit = parseFloat(units);
                const unitPrice = Math.round(netto / unit);
                const rounded = Math.round(unitPrice / 10);
                const result = '' + (rounded / 1000).toFixed(3);

                //if the third decimal is 0, remove it
                const c = result.split('.');
                if (c.length === 2 && c[1].length === 3 && c[1].charAt(2) === '0') {
                    return c[0] + '.' + c[1].charAt(0) + c[1].charAt(1);
                }

                if (result <= 0.0 || isNaN(result) || result === "Infinity") {
                    return "";
                }
                return result;
            } catch (error) {
                return "";
            }
        };

        const getFieldValue = (field) => {
            return data.productData.customFields[field].value;
        };

        const setFieldValue = (field, value) => {
            if(data.fieldName === field) {
                return;
            }

            let oldValue = ''+ data.productData.customFields[field].value;
            let newValue = ''+ value;
            if (oldValue === newValue) {
                return;
            }

            data.productData.customFields[field].value = newValue;
            data.productData.customFields[field].highlight = true;
            data.changeProductFieldValue(field, null, newValue);
        };

        const log = (message) => {
            
        };

        const toFloat = (value) => {
            return parseFloat(value.replace(',', '.'));
        }

        try {
            // Create a function with all needed utilities as parameters
            const scriptFunction = new Function(
                'getFieldValue',
                'setFieldValue',
                'roundToTwoDecimal',
                'roundToThreeDecimal',
                'calcPriceWithVat',
                'calcPricePerUnit',
                'toFloat',
                'log',
                script
            );

            // Execute the script with our utility functions
            try {
                scriptFunction(
                    getFieldValue,
                    setFieldValue,
                    roundToTwoDecimal,
                    roundToThreeDecimal,
                    calcPriceWithVat,
                    calcPricePerUnit,
                    toFloat,
                    log
                );
            } catch (error) {
                console.error('Error executing script:', error);
            }

            // Return the modified data
            //return dataCopy;
        } catch (error) {
            console.error('Error executing script:', error);
            //return data; // Return original data in case of error
        }
    }
};

export default Hooks;